import React from 'react';
import OptimizedQRCode from './OptimizedQRCode';

interface LazyQRCodeProps {
  value: string;
  size?: number;
  level?: 'L' | 'M' | 'Q' | 'H';
  includeMargin?: boolean;
  className?: string;
  style?: React.CSSProperties;
  bgColor?: string;
  fgColor?: string;
  imageSettings?: {
    src: string;
    height: number;
    width: number;
    excavate: boolean;
  };
  lazy?: boolean;
  priority?: 'high' | 'low';
  cacheKey?: string;
}

const LazyQRCode: React.FC<LazyQRCodeProps> = ({
  value,
  size = 256,
  level = 'M',
  includeMargin = false,
  className,
  style,
  bgColor = '#FFFFFF',
  fgColor = '#000000',
  imageSettings,
  lazy = true,
  priority = 'low',
  cacheKey,
  ...props
}) => {
  return (
    <OptimizedQRCode
      value={value}
      size={size}
      level={level}
      includeMargin={includeMargin}
      className={className}
      style={style}
      bgColor={bgColor}
      fgColor={fgColor}
      imageSettings={imageSettings}
      lazy={lazy}
      priority={priority}
      cacheKey={cacheKey}
      {...props}
    />
  );
};

export default LazyQRCode;
